/**
 * guests-only.guard.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot }
  from "@angular/router";
import { AuthService } from "../auth/auth.service";

@Injectable()
export class GuestsOnlyGuard implements CanActivate {
  constructor (private auth : AuthService) {}

  public canActivate (
    route : ActivatedRouteSnapshot,
    state : RouterStateSnapshot
  ) : boolean
  {
    // We want to reject when the user is logged in, so simply invert the
    // current authentication status.
    return !this.auth.authenticated;
    // TODO: Do we want some sort of notification here? I guess that'll depend
    // on the contexts we end up using it. It doesn't need one for login, since
    // that page should be hidden when we are logged-in, and going there would
    // be a deliberate error.
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/routing/guests-only.guard.ts